import React from "react";

const educationContent = [
  {
    year: "2021",
    degree: "PG Diploma in Computer Application",
    institute: "Panjab University, Chandigarh",
    details: [
      "• Completed advanced postgraduate studies focusing on modern software development methodologies and systems management",
      "• Maintained strong academic performance with an aggregate of 72.3%, demonstrating technical proficiency and a commitment to continuous learning"
    ]
  },
  {
    year: "2014",
    degree: "Bachelor of Science",
    institute: "M.J.P.R. University, Bareilly",
    details: [
      "• Graduated with First Class, achieved an overall score of 61.48%",
      "• Established a solid foundational knowledge in computational theory, data structures, and mathematics",
      "• Gained early exposure to programming logic and database management, which served as the catalyst for 9 years of professional growth in the tech industry"
    ]
  },
  {
    year: "2011",
    degree: "Intermediate",
    institute: "State Board of Uttar Pradesh",
    details: [
      "• Completed higher secondary education from the State Board of Uttar Pradesh",
      "• Focused on the Science stream and developed a solid academic base"
    ]
  },
];

const Education = () => {
  return (
    <ul>
      {educationContent.map((val, i) => (
        <li key={i}>
          <div className="icon">
            <i className="fa fa-briefcase"></i>
          </div>
          <span className="time open-sans-font text-uppercase">{val.year}</span>
          <h5 className="poppins-font text-uppercase">
            {val.degree}
            <span className="place open-sans-font">{val.institute}</span>
          </h5>
          {val?.details?.length && val.details.map((item, i) => (
            <p className="open-sans-font">{item}</p>
          ))}
        </li>
      ))}
    </ul>
  );
};

export default Education;
